var requireObjectCoercible = require('../internals/require-object-coercible');

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/to-object.js
// module id = 63
// module chunks = 0